import React, { useCallback, useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useDispatch, useSelector } from 'react-redux'
import { updateTenant } from '../../../store/actions/tenant.actions'
import Loading from '../../Loading/Loading'
import Template from '../Template'
import MediaQueryPage from '../../MediaQueryPage/MediaQueryPage'
import isEmpty from 'lodash/isEmpty'
import { getTenant } from '../../../services/tenant/tenant.service'
import { setDate } from '../../../store/actions/date.actions'
import TenantError from '../../TenantError/TenantError'
import { handlerErrorV2 } from '../../../utils/errors'
import PageUnderMaintenance from '../../PageUnderMaintenance/PageUnderMaintenance'

const Wrapper = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const tenant = useSelector(state => state?.tenant?.tenant);
  const dispatch = useDispatch();
  const mediaQuery = useMediaQuery({ query: '(min-width: 650px)' });

  const getData = useCallback(async () => {
    try {
      if (isEmpty(tenant)) {
        setLoading(true)
        const result = await getTenant();
        setLoading(false)
        if (!result.data && result.error) {
          setError(response.error.message || 'Tenant invalid')
        } else {
          dispatch(updateTenant(result.data))
          dispatch(setDate(result.data.date));
        }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setLoading(false)
    }
  }, [tenant])

  useEffect(() => {
    getData();
  }, [getData])

  if (error) return <TenantError />

  if (!mediaQuery) return (<MediaQueryPage />)
  if (loading) return <Template><Loading /></Template>
  if (tenant?.isUnderMaintenance) return <Template><PageUnderMaintenance /></Template>

  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  )
}

export default Wrapper
